export default "__VITE_ASSET__ce12741f__"